import { render } from "./FraudAssessmentCheck.vue.ts?vue&type=template&id=03ff432f&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FraudAssessmentCheck.vue?vue&type=template&id=03ff432f&ts=true"
import script from "./FraudAssessmentCheck.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FraudAssessmentCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./FraudAssessmentCheck.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FraudAssessmentCheck.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/apps/merchant3/components/customer-registration/customer-contact-info/FraudAssessmentCheck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03ff432f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03ff432f', __exports__)) {
    api.reload('03ff432f', __exports__)
  }
  
  module.hot.accept("./FraudAssessmentCheck.vue.ts?vue&type=template&id=03ff432f&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FraudAssessmentCheck.vue?vue&type=template&id=03ff432f&ts=true", () => {
    api.rerender('03ff432f', render)
  })

}


export default __exports__